import React from "react";
import "@/App.css";
import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { LangProvider } from "@/context/LangContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import Returns from "@/pages/Returns";
import ReturnNew from "@/pages/ReturnNew";
import ReturnDetail from "@/pages/ReturnDetail";
import Profile from "@/pages/Profile";
import UserManagement from "@/pages/UserManagement";
import AuditLog from "@/pages/AuditLog";
import Settings from "@/pages/Settings";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";

function App() {
  return (
    <BrowserRouter>
      <LangProvider>
        <SettingsProvider>
          <AuthProvider>
            <Toaster position="top-right" richColors closeButton />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/impressum" element={<Impressum />} />
                <Route path="/datenschutz" element={<Datenschutz />} />

                <Route
                  path="/dashboard"
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/returns"
                  element={
                    <ProtectedRoute>
                      <Returns />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/returns/new"
                  element={
                    <ProtectedRoute>
                      <ReturnNew />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/returns/:id"
                  element={
                    <ProtectedRoute>
                      <ReturnDetail />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <Profile />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/users"
                  element={
                    <ProtectedRoute adminOnly>
                      <UserManagement />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/audit"
                  element={
                    <ProtectedRoute adminOnly>
                      <AuditLog />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/settings"
                  element={
                    <ProtectedRoute adminOnly>
                      <Settings />
                    </ProtectedRoute>
                  }
                />
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
              </Route>
            </Routes>
          </AuthProvider>
        </SettingsProvider>
      </LangProvider>
    </BrowserRouter>
  );
}

export default App;
